// https://v3.docs.apostrophecms.org/guide/front-end-tips.html#register-js-to-keep-up-with-in-context-editing-events
import { saveJob, createAlerts, getFilters, getJobFilters, getSortValue, markSavedJobs } from '../../../../lib/helpers/jobHelpers';

import {
  addFilterDropdownListener,
  loadPageSize,
  removeCustomPageSize,
  setCurrentPageSize,
  setPageSizeEvent
} from '../../../../lib/helpers/common';
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';
export default () => {
  apos.util.widgetPlayers.simpleTabularJobSearch = {
    selector: '#simple-tabular-job-search-filters__form',
    player: function (searchForm) {
      if (searchForm) {
        const __t = JSON.parse(searchForm.dataset.localizedValues);
        const localePrefix = searchForm.dataset.localePrefix;

        var dropdownBtn = document.querySelector(".location-radius__button");
        var dropdownContent = document.querySelector("#contentDistance");
        var fields = document.getElementsByClassName('location-radius__field');

        const sortFilter = searchForm.querySelector('#sort-by-filter');
        if (sortFilter) { 
            sortFilter.addEventListener('change', () => {
              onFilterChange()
          })
        }

        if (dropdownContent) {
          for (var i = 0; i < fields.length; i++) {
            fields[i].addEventListener('click', function () {
              dropdownContent.style.display = "none";
            });
          }
          dropdownBtn.addEventListener("click", function () {
            if (dropdownContent.style.display === "block") {
              dropdownContent.style.display = "none";
            } else {
              dropdownContent.style.display = "block";
            }
          });
          document.addEventListener('click', function (event) {
            const isOutside = dropdownBtn.contains(event.target);
            if (!isOutside) {
              dropdownContent.style.display = "none";
            }
          });
        }

        searchForm.addEventListener('submit', (e) => {
          // Avoid submitting from 'Add Content' apos button
          if (e && e.submitter && e.submitter.classList.contains('apos-button')) e.preventDefault();

          displayAlerts();
          var allInputs = searchForm.getElementsByTagName('input');
          const selected = [];

          logWLAnalyticsEvent('Job Search Completed', {
            filterParams: getJobFilters(searchForm),
          });

          for (var i = 0; i < allInputs.length; i++) {
            var input = allInputs[i];

            if (input.name && !input.value) {
              input.name = '';
            }

            if (input.name && (((input.type == 'checkbox' || input.type == 'radio') && input.checked) || input.type == 'range')) {
              console.log(input)
              if (input.type == 'range' && (input.value == 0 || input.value == '0'))
                input.name = '';
              else if (!selected.includes(`${input.name}=${input.value}`))
                selected.push(`${input.name}=${input.value}`);
              else
                input.name = '';
            }
          }
        });

        var pageClick = false;
        loadLocationValues();
        loadPageSize(searchForm);
        addPageListeners();
        addLocationListeners();
        addKeywordListener();
        addSortListeners();
        addPageSizeListeners();
        addfilterOverlayListener();
        addFavoriteListener();

        /**
         * We want to simulate radio buttons that can be de-selected. Instead of using actual radios, we
         * use checkboxes that de-select all other checkboxes when selected.
         */
        const customRadios = searchForm.querySelectorAll('input[type=checkbox].custom-radio');
        customRadios.forEach((customRadio) => {
          customRadio.addEventListener('click', (e) => {
            if (customRadio.checked) {
              // Select checkboxes with same class list (should contain the same filter name as part of one of the classes)
              const groupSelector = customRadio.className.split(' ').map((className) => `.${className.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`)}`).join('');
              const groupedCustomRadios = searchForm.querySelectorAll(groupSelector)
              groupedCustomRadios.forEach((groupedCustomRadio) => {
                if (customRadio != groupedCustomRadio) groupedCustomRadio.checked = false
              });
            }
          })
        })

        const clearAllButtons = searchForm.querySelectorAll('.clear-all-button');
        clearAllButtons.forEach(button => button.addEventListener('click', clearAll));

        function clearAll() {
          // Reset all text inputs
          const textInputs = searchForm.querySelectorAll('input[type=text]');
          textInputs.forEach((input) => {
            input.value = '';
          });

          // Clear google auto-suggest input
          const locationInput = searchForm.querySelector('#Facility\\.location');
          locationInput && (locationInput.value = '');

          // Remove all mutli select inputs
          const mutliSelectInputs = searchForm.querySelectorAll('.multi-select-filter-value');
          mutliSelectInputs.forEach((input) => {
            input.remove();
          });

          // Select all checked inputs and set their checked to false
          const inputs = searchForm.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked');
          inputs.forEach((input) => {
            input.checked = false;
          });

          // Reset Location Radius
          const defaultRadius = 50;
          const locationLabel = searchForm.querySelector('.location-radius__wrapper');
          if (locationLabel) {
            locationLabel.querySelector('span').innerHTML = defaultRadius;
            locationLabel.classList.remove('hidden');
          }

          const radiusSelector = searchForm.querySelector('.location-radius__fields');
          if (radiusSelector) {
            radiusSelector.querySelector(`#Facility\\.radius__${defaultRadius}`).checked = true;
          }

          removeCustomPageSize(searchForm);

          onFilterChange();
        }

        // if found location values in the page URL load then to its correspondent fields
        function loadLocationValues() {
          const queryParams = new URLSearchParams(window.location.search);

          const shortName = searchForm.querySelector('#Facility\\.location\\.shortName');
          const type = searchForm.querySelector('#Facility\\.location\\.type');
          const lat = searchForm.querySelector('#Facility\\.location\\.lat');
          const lng = searchForm.querySelector('#Facility\\.location\\.lng');

          if (shortName && !shortName.value && queryParams.get('location-short')) {
            shortName.value = queryParams.get('location-short');
          }
          if (type && !type.value && queryParams.get('location-type')) {
            type.value = queryParams.get('location-type');
          }
          if (lat && !lat.value && queryParams.get('location-lat')) {
            lat.value = queryParams.get('location-lat');
          }
          if (lng && !lng.value && queryParams.get('location-lng')) {
            lng.value = queryParams.get('location-lng');
          }
        }

        function onDocumentClick(el) {
          var dropDowns = searchForm.getElementsByClassName('dropdown-fields');
          for (var i = 0; i < dropDowns.length; i++) {
            if (el.id != dropDowns[i].parentNode.querySelector('input').id && el.id != 'subcategoryArrow') {
              dropDowns[i].parentNode.removeChild(dropDowns[i]);
            }
          }
        }

        document.addEventListener('click', (e) => onDocumentClick(e.target));

        function addPageListeners() {
          const pageLinks = searchForm.querySelectorAll('.page-link');
          pageLinks.forEach((pageLink) => {
            const page = parseInt(pageLink.dataset['page'])

            pageLink.addEventListener('click', function () {
              pageClick = true
              if (!pageLink.classList.contains('selected')) {
                onFilterChange(page);
              }
            });
          })
          if (!pageClick) {

            const re = /page\d*/
            const pageValue = re.exec(window.location)
            if (pageValue) {
              var pageNumber = pageValue[0].substring(4)
              pageClick = true
              onFilterChange(pageNumber)
            }
          }
        }

        function addKeywordListener() {
          const keywordInput = searchForm.querySelector('.keyword-search-input input');

          keywordInput.addEventListener('keydown', function (e) {
            if (e.keyCode === 13) {
              onFilterChange();
            }
          })
        }

        function addLocationListeners() {
          // Prevent form submission to let google autocomplete fetch location essential fields
          const locationInput = searchForm.querySelector('#Facility\\.location');
          if (locationInput) {
            locationInput.addEventListener('keypress', (e) => e.key === 'Enter' && e.preventDefault());

            locationInput.addEventListener('change', () => {
              // clean value on change and let google maps load it again if choose a valid location
              const shortName = searchForm.querySelector('#Facility\\.location\\.shortName');
              const type = searchForm.querySelector('#Facility\\.location\\.type');
              const lat = searchForm.querySelector('#Facility\\.location\\.lat');
              const lng = searchForm.querySelector('#Facility\\.location\\.lng');

              if (shortName) {
                shortName.value = '';
              }

              if (type) {
                type.value = '';
              }

              if (lat) {
                type.value = '';
              }

              if (lng) {
                lng.value = '';
              }
            });

            locationInput.addEventListener('updateLocation', () => {
              // perform onFilterChange only if location-short is loaded
              const locationShortInput = searchForm.querySelector('input[name="location-short"]');
              if (locationShortInput.value) {
                onFilterChange();
              }
            });
          }

          const radiusButton = searchForm.querySelector('.location-radius__button');
          const radiusMenu = searchForm.querySelector('.location-radius__fields');
          if (radiusButton && radiusMenu) {
            radiusButton.addEventListener('click', () => radiusMenu.classList.toggle('expand'));
            const radiusInputs = radiusMenu.querySelectorAll('input[type=radio]');
            radiusInputs.forEach(input => {
              input.addEventListener('click', () => {
                radiusButton.querySelector('span').innerHTML = input.value;
                radiusMenu.classList.remove('expand');
              });

              const locationShortInput = searchForm.querySelector('input[name="location-short"]');
              input.addEventListener('change', (event) => {
                if (event.target?.checked) {
                  // check location-short to ensure that a location is present
                  if (locationShortInput && locationShortInput.value) {
                    onFilterChange();
                  }
                }
              });
            });

            document.addEventListener('click', function (e) {
              if (!e.target.closest('.location-radius__wrapper')) {
                radiusMenu.classList.remove('expand');
              }
            });
          }
        }

        function addSortListeners() {
          const mainSelector = '.job-search__filters__sort';
          addFilterDropdownListener(searchForm, mainSelector, onFilterChange, 'sort');
        }

        function addPageSizeListeners() {
          const pageSizeSelectors = searchForm.querySelectorAll('.page-size-selector');

          if (pageSizeSelectors) {
            pageSizeSelectors.forEach(pageSizeSelector => pageSizeSelector.addEventListener('change', e => {
              setPageSizeEvent(e, searchForm);
              onFilterChange();
            }));
          }
        }

        function addFavoriteListener() {
          const saveIcons = searchForm.querySelectorAll('.icon-favorite');
          saveJob(saveIcons);
        }

        function addfilterOverlayListener() {

          const filtersOverlayCloseButton = searchForm.querySelector('#close-overlay-button');
          const filtersOverlayButton = searchForm.querySelector('#filters-overlay-button');
          const filter = searchForm.querySelector('.filters__advanced');

          if (filtersOverlayButton) {
            filtersOverlayButton.addEventListener('click', () => {
              filter.classList.add('open');
              document.querySelector('body').style.overflowY = 'hidden';
            });
          }

          if (filtersOverlayCloseButton) {
            filtersOverlayCloseButton.addEventListener('click', () => {
              filter.classList.remove('open');
              document.querySelector('body').style.overflowY = 'visible';
            });
          }
        }
        function onChangeEnableJobAlert() {
          const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
          if (jobAlertsLabel && jobAlertsLabel.innerHTML == 'Alerts saved') {
            jobAlertsLabel.innerHTML = '';
            jobAlertsToggle.classList.remove('hidden');
            const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
            const jobAlertsSuccess = searchForm.querySelector('#job-alert-success');
            jobAlertsSuccess.classList.add('hidden');
            jobAlertsForm.classList.remove('hidden');
            searchForm.querySelector('#show-login-error-message').style.display = "none"
            searchForm.querySelector('#show-error-message').innerHTML = '';
          }
        }
        async function onFilterChange(page = 1, trackEvent = true) {
          toggleProgressIndicators()
          displayAlerts()
          onChangeEnableJobAlert()
          const filters = getAllInputValues();
          const widgetConfig = getWidgetConfig();
          const jobData = await getJobs(page, widgetConfig, filters);
          renderJobsResults(jobData);
          toggleProgressIndicators();

          // We need to re-add event listeners since the sort and pagination elements are re-rendered
          addPageListeners();
          addFavoriteListener();

          addPageSizeListeners();
          setCurrentPageSize(searchForm);
          trackEvent && logWLAnalyticsEvent('Job Search Completed', {
            filterParams: getJobFilters(searchForm),
            sortType: getSortValue(searchForm),
          });
        }
        function displayAlerts() {
          const alertsModal = searchForm.querySelector('#job-alerts-hide')
          if (alertsModal) {
            alertsModal.style.display = 'block'
          }
        }
        function toggleProgressIndicators() {
          const button = searchForm.querySelector('.job-search__filters__basic-filters > .button-wrapper > button');
          if (button) {
            const searchIcon = button.querySelector('svg');
            const spinner = button.querySelector('.spinner-border');
            if (searchIcon && spinner) {
              if (searchIcon.classList.contains('hidden')) {
                searchIcon.classList.remove('hidden');
                spinner.classList.add('hidden')
              }
              else {
                searchIcon.classList.add('hidden');
                spinner.classList.remove('hidden');
              }
            }
          }

          const placeholderList1 = searchForm.querySelector('#loading-placeholder');
          const jobsList1 = searchForm.querySelector('#jobs-list__list');
          if (placeholderList1 && jobsList1) {
            if (placeholderList1.classList.contains('hidden')) {
              placeholderList1.classList.remove('hidden');
              jobsList1.classList.add('hidden')
            } else {
              placeholderList1.classList.add('hidden');
              jobsList1.classList.remove('hidden')
            }
          }
          /* theme2 placeholder --starts */
          const placeholderList = searchForm.querySelector('#loading-placeholder-theme2');
          const jobsList = searchForm.querySelector('#jobs-list-theme2');
          if (placeholderList && jobsList) {
            if (placeholderList.classList.contains('hidden')) {
              placeholderList.classList.remove('hidden');
              jobsList.classList.add('hidden')
            } else {
              placeholderList.classList.add('hidden');
              jobsList.classList.remove('hidden')
            }
          }
          /* ends */
        }

        function getAllInputValues() {
          let selectors = 'input[type=text], input[type=checkbox]:checked, input[type=radio]:checked, input[type=range], '
          if (screen.width > 991) {
            selectors += '#sort-by-filter'
          } else {
            selectors += '#sort-by-filter-lg'
          }
          const checkedInputs = searchForm.querySelectorAll(selectors);
          const filters = [];
          if(searchForm.dataset['defaultfilter']){
             filters.push(searchForm.dataset['defaultfilter']);
          }
          var mainCategory = null;
          checkedInputs.forEach((input) => {
            if (input.classList.contains('filterCategory')) {
              var category = input.getAttribute('data-category')
              if (category == 'main' && input.checked == true && input.indeterminate != true) {
                mainCategory = input.getAttribute('data-value')
                filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
              }
              else if (category == 'sub' && input.getAttribute('data-mainvalue') != mainCategory) {
                filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
              }

            }

            else {
              if (input.type === 'range' && (input.value === "0" || input.value === 0)) return;
              if (input.value && !filters.includes(`${input.name}=${input.value}`) && input.name != '') {
                filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
              }
            }

          })
          return filters.join('&');
        }

        function getWidgetConfig() {
          const widgetConfig = {
            defaultFilter : searchForm.dataset['defaultfilter'],
            limit: searchForm.dataset['limit'],
            allowUserDefinePageSize: searchForm.dataset['allowUserDefinePageSize'],
            defaultPageSize: searchForm.dataset['defaultLimit'],
            referralPill: searchForm.dataset['referralpill'],
            referralText: searchForm.dataset['referraltext'],
            jobTitle: searchForm.dataset['jobtitle'],
            savedJob: searchForm.dataset['savedjob'],
            description: searchForm.dataset['description'],
            highlights: searchForm.dataset['highlights'],
            theme2Highlights: searchForm.dataset['theme2highlights'],
            theme2HighlightsCol1: searchForm.dataset['theme2highlightscol1'],
            displayLogo: searchForm.dataset['displaylogo']
          };
          const config = [];
          for (const [key, value] of Object.entries(widgetConfig)) {
            config.push(`${key}=${value}`);
          }
          return config.join('&');
        }

        async function getJobs(page, config, filters) {
          try {
            /**
             * Alternatively, for leveraging a built-in Apostrophe API that comes with each page to load a rendered template HTML string
             * https://v3.docs.apostrophecms.org/reference/api/pages.html#get-url-aposrefresh-1
             *
             * const searchResultsPage = await fetch(`?aposRefresh=1&${page ? `page=${page}&` : ''}${filters}`);
             *
             * Note:
             *  This allows a fetch to a relative URL, so the job search widget can be placed on any page and the same page will be requested.
             * The only problem is this requests the entire page so it is not as efficient as using a renderRoutes API.
             */

            // Calling an API route created with the job-search-widget module using renderRoutes
            // https://v3.docs.apostrophecms.org/reference/module-api/module-overview.html#renderroutes-self
            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-simple-tabular-widget/job-search?${page ? `page=${page}&` : ''}${config}&${filters}`);
            
            if (page == 1) {
              window.history.replaceState(null, null, "?" + filters)
            }
            else {
              window.history.replaceState(null, null, "?" + filters + "&page" + page)
            }
            return searchResults.text();
          } catch (e) {
            console.error(e);
          }
          return;
        }

        function renderJobsResults(htmlString) {
          const htmlDoc = document.createElement('html')
          htmlDoc.innerHTML = htmlString
          searchForm.querySelector('#pagination-nav').innerHTML = htmlDoc.querySelector('#pagination-nav').innerHTML;
          const jobSearchFilterResult = searchForm.querySelector('#job-search__filters__results')
          if (jobSearchFilterResult) {
            jobSearchFilterResult.innerHTML = htmlDoc.querySelector('#job-search__filters__results').innerHTML;
          }
          const joblistList = searchForm.querySelector('#jobs-list__list')
          if (joblistList) {
            joblistList.innerHTML = htmlDoc.querySelector('#jobs-list__list').innerHTML;
          }
          const jobListTheme2 = searchForm.querySelector('#jobs-list-theme2')

          if (jobListTheme2) {
            jobListTheme2.innerHTML = htmlDoc.querySelector('#jobs-list-theme2').innerHTML
          }
          const controlsLabels = searchForm.querySelector('#job-search__filters__info__controls__labels');
          if (controlsLabels) {
            controlsLabels.innerHTML = htmlDoc.querySelector('#job-search__filters__info__controls__labels').innerHTML;
          }

          markSavedJobs();
        }

        /**
         * Job Alerts
         */
        const jobAlertsToggle = searchForm.querySelector('#job-alerts-toggle');
        if (jobAlertsToggle) {

          const jobAlertsModal = searchForm.querySelector('.job-alerts-modal');
          jobAlertsToggle.addEventListener('change', () => {
            if (jobAlertsToggle.checked) {
              jobAlertsModal.classList.remove('hidden');
            } else {
              jobAlertsModal.classList.add('hidden');
            }
          });

          const jobAlertsSubmit = searchForm.querySelector('#job-alerts-save-button');
          if (jobAlertsSubmit) {
            jobAlertsSubmit.addEventListener('click', onJobAlertsSubmit)
          }

          const jobAlertsCancel = searchForm.querySelector('#job-alerts-cancel-button');
          if (jobAlertsCancel) {
            jobAlertsCancel.addEventListener('click', onCloseJobAlertsModal)
          }

          const jobAlertsOk = searchForm.querySelector('#job-alerts-ok-button');
          if (jobAlertsOk) {
            jobAlertsOk.addEventListener('click', onFinishJobAlerts);
          }

          function onCloseJobAlertsModal() {
            if (jobAlertsModal) {
              jobAlertsToggle.checked = false;
              jobAlertsModal.classList.add('hidden');
            }
          }

          async function getJobAlertFilterParams() {
            const urlParams = getAllInputValues()
            var paramArray = urlParams.split('&')
            var req = {}
            for (var i = 0; i < paramArray.length; i++) {
              const [key, value] = paramArray[i].split('=');
              if (req[key]) {
                req[key] += "," + decodeURIComponent(value);
              }
              else {
                req[key] = decodeURIComponent(value)
              }

            }
            var fillers = await getFilters();

            var filters = fillers.data.jobFilterMetaDataVOList
            const filterArgs = Object.entries(req);
            // Format the args for the job search API
            const formattedFilterArgs = filterArgs.map(([key, _value]) => {
              const filter = filters.find((filter) => filter.slugAlias === key);
              if (filter && _value) {
                if (filter.displayType === 'salaryrange' && (_value === 0 || _value === '0')) return;

                let value = _value;
                if (Array.isArray(_value)) {
                  const values = _value.map((x) => {
                    const selectedOption = filter.filterValues.find((option) => option.label === x)
                    if (selectedOption) {
                      return selectedOption.value
                    }
                  });
                  value = values.join(',');
                }
                else if (filter.filterValues) {
                  const selectedOption = filter.filterValues.find((option) => option.label.replace(/\n/g, '') === _value)
                  if (selectedOption) {
                    value = selectedOption.value
                  }
                }
                if (filter.slugAlias === 'category') {
                  value = JSON.stringify({ categoryIds: value.split(',') })
                }
                if (value)
                  return {
                    name: filter.name,
                    label: filter.label,
                    displayType: filter.displayType,
                    fieldType: filter.fieldType,
                    value
                  }
              }
            }).filter((filterArg) => !!filterArg);

            const sortFilter = filters.find(filter => filter.name === 'JobPosting.SortCriteria');
            const sortFilterDefaultValue = sortFilter?.filterValues[0]?.value
            const selectedSortFilter = req['sort-by'] || sortFilterDefaultValue
            const extraConfig = sortFilter?.extraConfig || {}


            const sortCriteria = {
              sortField: selectedSortFilter,
              sortOrderAsc: extraConfig[selectedSortFilter] === 'asc' ? true : false
            };

            const location = req['location'];
            const radius = req['within'];
            const latitude = location ? req['location-lat'] : '';
            const longitude = location ? req['location-lng'] : '';


            var locationparam = {
              location,
              latLong: { latitude, longitude },
              locationType: location ? req['location-type'] : '',
              locShortName: location ? req['location-short'] : '',
              radius: radius
            }
            const jobFilters = { formattedFilterArgs, sortCriteria, locationparam }
            return jobFilters
          }
          var urlParams = getAllInputValues()
          var paramArray = urlParams.split('&')
          if (paramArray.length > 0) {
            paramArray.forEach(filter => {
              const [key, value] = filter.split('=');
              if (key == 'location' || key == 'job-search') {
                displayAlerts()
                return null
              }
            })

          }
          async function onJobAlertsSubmit() {
            const jobAlertsEmailInput = document.querySelector('#job-alerts-email-input');
            const termsAndConditions = searchForm.querySelector('#terms')
            const jobAlertName = searchForm.querySelector('#job-alerts-name-input')
            var frequency = document.querySelector('input[name="job-alert-frequency"]:checked').value
            jobAlertName.setCustomValidity('');
            if (jobAlertName.value.length < 3) {
              displayValidationMessage(jobAlertName, __t['jobAlert.nameErrorInvalid']);
              return null;
            }
            else if (!(jobAlertsEmailInput && jobAlertsEmailInput.value && validateEmail(jobAlertsEmailInput.value))) {
              displayValidationMessage(jobAlertsEmailInput, __t['jobAlert.emailErrorInvalid']);
              return null;
            }
            else if (!termsAndConditions.checked) {
              displayValidationMessage(termsAndConditions, __t['jobAlert.termsServiceErrorRequired']);
              return null
            }
            else {
              const filterValues = await getJobAlertFilterParams()

              const response = await createAlerts({
                email: jobAlertsEmailInput.value,
                name: jobAlertName.value,
                jobAlertFrequency: frequency,
                jobAlertConfigDetails: { jobParamRequests: filterValues.formattedFilterArgs, locationInfo: filterValues.locationparam, sortCriteria: filterValues.sortCriteria, text: "" }
              });
              if (!response.success) {
                if (response.errorMessage == 'You already have an account. Please log in to create a job alert.') {
                  searchForm.querySelector('#show-login-error-message').style.display = "block"
                }
                else {
                  searchForm.querySelector('#show-error-message').innerHTML = response.errorMessage
                }
                //  errorMessage.innerHTML= 'You already have an account. Please'+ <a href="https://google.com">+'log in'+ </a>+'to create a job alert.'
                return null;
              }

              const jobAlertsEmail = searchForm.querySelector('#job-alerts-email');
              if (jobAlertsEmail) {
                jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
              }
              const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
              const jobAlertsSuccess = searchForm.querySelector('.job-alerts__card.hidden');
              jobAlertsForm.classList.add('hidden');
              jobAlertsSuccess.classList.remove('hidden');
              if (jobAlertsEmail && jobAlertsEmailInput) {
                jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
              }

              jobAlertsEmailInput.value = '';
              termsAndConditions.checked = false;
              jobAlertName.value = __t['jobAlert.nameDefaultValue']
              searchForm.querySelector('#dailyRadio').checked = true;
            }
          }

          function onFinishJobAlerts() {
            onCloseJobAlertsModal();
            jobAlertsToggle.classList.add('hidden');
            const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
            if (jobAlertsLabel) {
              jobAlertsLabel.innerHTML = 'Alerts saved';
            }
          }
          function validateEmail(email) {
            return String(email)
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              );
          };
          function displayValidationMessage(field, message) {
            try {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
            } catch (err) {
              console.log(err);
            }
          }

          document.addEventListener('click', function (e) {
            if (!e.target.closest('.job-search__filters__switch')) {
              onCloseJobAlertsModal();
            }
          });
        }
      }
    }
  };
};
